'use strict';

export function EMPTY_FUNC(){
};

// is array
export function isArray(v){
  return (v instanceof Array) || (typeof(v) == 'object' && typeof(v.length) == 'number');
};
// merge
export function merge(base) {
  const ret = base ? base : {};
  const al = arguments.length;
  let i, k;
  for (i = 1; i < al; i++) {
    let s = arguments[i];
    if (s === null || typeof(s) == 'undefined') {
      continue;
    }
    for (k in s) {
      ret[k] = s[k];
    }
  }
  return ret;
};

export function each(ary, cb){
  if (!ary || !ary.length) {
    return;
  }
  const l = ary.length;
  let i = 0;
  while (i < l) {
    if (cb.call(ary, ary[i], i) === false) {
      return ary;
    }
    i++;
  }
  return ary;
};

export function arrayRemove(array, target) {
  each(array, function(obj, idx){
    if (obj == target) {
      array.splice(idx, 1);
      return false;
    }
  });
  return array;
};

export function createPrivateMapper(){
  const map = new WeakMap();
  return function(obj) {
    if (!map.has(obj)) {
      map.set(obj, {});
    }
    return map.get(obj);
  };
}


// create XMLHttpRequest
const createXhr = (function(){
  const msActiveXArray = ["Msxml2.XMLHTTP", "Msxml3.XMLHTTP", "Microsoft.XMLHTTP"];
  if (window.XMLHttpRequest) {
    return function(){
      return new XMLHttpRequest();
    };
  } else if (window.ActiveXObject) {
    let msActiveXObj = null;
    const l = msActiveXArray.length;
    for (let i = 0; i < l; i++) {
      try {
        /* eslint no-new: 0 */
        new ActiveXObject(msActiveXArray[i]);
        msActiveXObj = msActiveXArray[i];
        break;
      } catch (e) {
        continue;
      }
    }
    if (msActiveXObj) {
      return function(){
        return new ActiveXObject(msActiveXObj);
      };
    }
  }
  return null;
})();

// AJAX request
const ajax = (function(){
  // default options
  const defaultOptions = {
    url: '',
    async: true,
    method: 'GET',
    data: null,
    responseType: null
  };

  if (!createXhr) {
    // AJAX not supported
    return null;
  }

  // AJAX function
  return function(options){
    let req = createXhr();
    let o = merge({}, defaultOptions, options);
    let url = o.url;
    // sucess
    let success = function(){
      if (o && typeof(o.success) == 'function') {
        o.success.call(null, req);
      }
    };
    // failure
    let failure = function(msg){
      if (o && typeof(o.failure) == 'function') {
        o.failure.call(null, req);
      }
    };
    // abort
    let abort = function(ev){
      if (o && typeof(o.abort) == 'function') {
        o.abort.call(null, ev);
      }
    }
    // always
    let always = function(){
      if (o && typeof(o.always) == 'function') {
        o.always.call(null);
      }
    }
    // progress
    let progress = function(ev){
      if (o && typeof(o.progress) == 'function') {
        o.progress.call(null, ev);
      }
    }
    // close request
    let closeReq = function(){
      req.abort();
      req.onreadystatechange = null;
      req = null;
      o = null;
      success = null;
      failure = null;
      progress = null;
      always = null;
    }
    try {
      let sendData;
      req.open(o.method, url, o.async);
      if (sendData && o.method == 'POST') {
        req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      }
      if (o.responseType) {
        req.responseType = o.responseType;
      }
      req.send(o.data);
    } catch (e) {
      failure(e);
      closeReq();
      closeReq = null;
      return req;
    }
    if (o.async) {
      req.onprogress = function(ev){
        if (!progress) {
          return;
        }
        progress(ev);
      }
      req.onreadystatechange = function(){
        if (req.readyState === 4) {
          if (req.status === 200) {
            success();
          } else if (req.status === 0) {
            abort(req);
          } else if (req.status !== 0) {
            failure(req);
          }
          always();
          closeReq();
          closeReq = null;
        }
      };
    } else {
      if (req.status === 200) {
        success();
      }
      closeReq();
      closeReq = null;
    }
    return req;
  };
})();

export function loadImage(params) {
  const url = params.url;
  const successCallback = params.success ? params.success : EMPTY_FUNC;
  const failureCallback = params.failure ? params.failure : EMPTY_FUNC;
  const abortCallback = params.abort ? params.abort : EMPTY_FUNC;
  const alwaysCallback = params.always ? params.always : EMPTY_FUNC;
  const img = document.createElement('img');
  let isAborted = false;
  const onloadFunc = function(ev){
    removeListeners();
    successCallback(img);
    alwaysCallback(ev);
  }
  const onerrorFunc = function(ev){
    removeListeners();
    if (isAborted) {
      abortCallback(ev);
    } else {
      failureCallback(ev);
    }
    alwaysCallback(ev);
  }
  const onabortFunc = function(ev){
    removeListeners();
    abortCallback(ev);
    alwaysCallback(ev);
  }
  const removeListeners = function(){
    img.removeEventListener('load', onloadFunc);
    img.removeEventListener('error', onerrorFunc);
    img.removeEventListener('abort', onabortFunc);
  }
  img.addEventListener('load', onloadFunc);
  img.addEventListener('error', onerrorFunc);
  img.addEventListener('abort', onabortFunc);
  img.src = url;
  return {
    abort: function(){
      isAborted = true;
      img.src = '';
    }
  }
}

export {ajax};
